import React from 'react';

import { GRAPH_WIDTH } from 'common/timeAxis';

const GraphFrame = ({
  steps,
  verticalGuides = [],
  children,
}: {
  steps: number,
  verticalGuides?: number[], // fractions 0..1 across the width, aligned to axis ticks
  children: React.ReactNode,
}) => (
  <svg viewBox={`0 0 ${GRAPH_WIDTH} 1000`} className='plot' preserveAspectRatio='none'>
    <defs>
      <linearGradient id='scoring_hashrate' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90)'>
        <stop offset='0%' stopColor='#00c8d4'stopOpacity='0.5' />
        <stop offset='35%' stopColor='#5cd5ff' stopOpacity='0' />
      </linearGradient>
      <linearGradient id='hashrate' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90)'>
        <stop offset='0%' stopColor='#6c69da'stopOpacity='0.5' />
        <stop offset='20%' stopColor='#3a6ff8' stopOpacity='0' />
      </linearGradient>
      <linearGradient id='workers_active' gradientUnits='userSpaceOnUse' gradientTransform='rotate(90)'>
        <stop offset='0%' stopColor='#f90' stopOpacity='0.5'/>
        <stop offset='20%' stopColor='#ffc200' stopOpacity='0' />
      </linearGradient>
    </defs>
    { [...Array(isNaN(steps) ? 0 : steps).fill(true)].map((v, k) => (
      <line
        key={k}
        x1='0'
        y1={(k + 1) * 1000 / steps}
        x2={GRAPH_WIDTH}
        y2={(k + 1) * 1000 / steps}
        className='bg-line'
      />
    )) }
    { verticalGuides.map((fraction, k) => (
      <line
        key={k}
        x1={fraction * GRAPH_WIDTH}
        y1='0'
        x2={fraction * GRAPH_WIDTH}
        y2='1000'
        className='bg-line'
      />
    )) }
    {children}
  </svg>
);

export default GraphFrame;
